import { render } from "./NewStaffForm.vue?vue&type=template&id=0361f232&scoped=true"
import script from "./NewStaffForm.vue?vue&type=script&lang=js"
export * from "./NewStaffForm.vue?vue&type=script&lang=js"

import "./NewStaffForm.vue?vue&type=style&index=0&id=0361f232&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0361f232"]])

export default __exports__